import { Typography } from "@mui/material";
import type { ConditionField } from "../../../../../../../../api/types/svTypes.ts";
import { getFieldCaption } from "../../../../utilities/Utilities.tsx";
import PrimaryCaption from "../fields/field-captions/PrimaryCaption.tsx";

interface Props {
  field: ConditionField;
  captionColor?: string;
  captionVariant?: "caption" | "body1";
}
export default function ConditionDimensionCaption({ field, captionColor, captionVariant }: Props) {
  const caption = getFieldCaption(field);
  const isMandatory = field.config.mandatory;

  return (
    <PrimaryCaption captionVariant={captionVariant} captionColor={captionColor} text={caption}>
      {isMandatory && (
        <Typography variant="caption" sx={{ color: (theme) => theme.palette.error.main }}>
          *
        </Typography>
      )}
    </PrimaryCaption>
  );
}
